import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { ACCOUNT_FEATURE_GROUP } from './group';

export const ACCOUNT_FEATURES = {
  READ: {
    guid: 'f2c5db56-8e40-4fa1-b234-9f1f2e3c0000',
    name: 'account:read',
    description: 'View personal account details',
    action: 'read',
    product: 'account',
    parentGuid: ACCOUNT_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'f2c5db56-8e40-4fa1-b234-9f1f2e3c0001',
    name: 'account:update',
    description: 'Edit personal account details, password, email, and phone',
    action: 'update',
    product: 'account',
    parentGuid: ACCOUNT_FEATURE_GROUP.guid,
  },
  TWO_FACTOR_AUTHENTICATION: {
    guid: 'f2c5db56-8e40-4fa1-b234-9f1f2e3c0002',
    name: 'account:two_factor_authentication',
    description: 'Enable or disable two-factor authentication for the account',
    action: 'update',
    product: 'account',
    parentGuid: ACCOUNT_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { ACCOUNT_FEATURE_GROUP } from './group';

export const ACCOUNT_MODULE: FeatureModule = {
  product: 'account',
  groups: [ACCOUNT_FEATURE_GROUP],
  features: featureList(ACCOUNT_FEATURES),
};
